<template>
  <el-dialog :title="getTitle" top="50px" :visible.sync="dailogShow" width="80%" :close-on-click-modal="false" :before-close="handleClose" append-to-body @open="handleOpen">
    <el-form ref="postForm" :model="postForm" :rules="rules" label-width="100px" class="demo-ruleForm" label-position="right">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item prop="scheName" label="日程名称">
            <el-input v-model="postForm.scheName" maxlength="50" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="workTaskScheMemList" label="执行者">
            <el-select v-model="postForm.workTaskScheMemList" :disabled="isEdit" multiple placeholder="请选择执行者">
              <el-option v-for="item in allKetiMemberList" :key="item.id" :value="item.id" :label="item.userName" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="scheDateTimeStart" label="时间">
            <el-date-picker
              v-model="postForm.scheDateTimeStart"
              type="datetime"
              clearable
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-ddTHH:mm"
              @change="handleBeginDateChange"
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item prop="scheDateTimeEnd" label="~">
            <el-date-picker
              v-model="postForm.scheDateTimeEnd"
              type="datetime"
              clearable
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-ddTHH:mm"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="remark" label="备注">
            <el-input v-model="postForm.remark" type="textarea" :rows="3" maxlength="250" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="scheOperDetail" label="执行详细">
            <el-input v-model="postForm.scheOperDetail" type="textarea" :rows="3" maxlength="250" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="scheStatusDictKey" label="状态">
            <el-radio-group v-model="postForm.scheStatusDictKey">
              <el-radio-button v-for="item in getComboxData('D99')" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="postForm.scheStatusDictKey === 'D9902'" :span="12">
          <el-form-item prop="scheCompleteDT" label="完成时间">
            <el-date-picker
              v-model="postForm.scheCompleteDT"
              type="datetime"
              clearable
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-ddTHH:mm"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="附件">
            <WorkTaskFile
              v-model="fileListSche"
              :is-can-edit="true"
              :module-code="moduleCode"
              :module-key="moduleKey"
              :task-id="entityId"
              file-type="D9604"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>

    <div class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSave()">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
// import Combox from '@/views/managesystem/gz/com/Combox'
import KxjCom from '@/utils/kxjcom'
import WorkTaskFile from './WorkTaskFile'
import { parseTime } from '@/utils/index'
export default {
  components: {
    // Combox
    WorkTaskFile
  },
  props: {
    entityId: { type: Number, default: null },
    taskId: { type: Number, default: null },
    moduleCode: { type: String, default: '' },
    moduleKey: { type: Number, default: null }
  },
  data() {
    return {
      dailogShow: false,
      allComboxData: [],
      postForm: {},
      allKetiMemberList: [],
      activeName: 'first',
      disContent: '',
      disList: [],
      operLogList: [],
      rules: {
        scheName: [
          { required: true, message: '请输入日程名称', trigger: 'change,blur' }
        ],
        scheDateTimeStart: [
          { required: true, message: '请选择开始时间', trigger: 'change,blur' }
        ],
        scheDateTimeEnd: [
          { required: true, message: '请选择结束时间', trigger: 'change,blur' }
        ],
        workTaskScheMemList: [
          { required: true, message: '请选择参与者', trigger: 'change,blur' }
        ],
        workTaskStatusDictKey: [
          { required: true, message: '请选择状态', trigger: 'change,blur' }
        ]
      },
      checkInfo: {},
      allTempFiles: [],
      fileList: [],
      fileListSche: []
    }
  },
  /** 计算 */
  computed: {
    isEdit() {
      return !!this.entityId
    },
    getTitle() {
      return (this.entityId ? '编辑日程' : '新增日程')
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          if (!this.postForm.scheDateTimeStart) {
            return false
          } else {
            return time <= new Date(this.postForm.scheDateTimeStart)
          }
        }
      }
    }
  },
  /** 创建 */
  created() {
    const that = this
    // 取得所有下拉框数据 逗号隔开
    pathReq.getComboxDatasByIdArray('D99').then(res => {
      that.allComboxData = res.data.result
    })
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter((item) => {
        return item.typeId === typeId
      })
    },
    show() {
      this.dailogShow = true
    },
    handleClose() {
      this.$refs['postForm'].resetFields()
      this.dailogShow = false
    },
    handleOpen() {
      const that = this
      let path = '/api/services/app/WorkTaskSche/GetEditWorkTaskSche'
      path += '?TaskId=' + this.taskId
      path += '&moduleCode=' + this.moduleCode
      path += '&moduleKey=' + this.moduleKey

      if (this.entityId) {
        path += '&Id=' + this.entityId
      }

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq.getNoParams(path).then(res => {
        that.postForm = res.data.result.entityData
        that.allKetiMemberList = res.data.result.allKetiMemberList
        that.allTempFiles = res.data.result.workTaskFiles
        that.fileListSche = that.allTempFiles.filter(x => x.filetype === 'D9604')
      }).then(_ => {
        loading.close()
      })
    },
    /** 开始时间变化 */
    handleBeginDateChange() {
      if (!this.postForm.scheDateTimeStart) {
        return
      }
      var t1 = new Date(this.postForm.scheDateTimeStart)
      var t2 = parseTime(t1.setHours(t1.getHours() + 1))
      var t3 = t2.slice(0, 10) + 'T' + t2.slice(11)
      this.postForm.scheDateTimeEnd = (t3)
    },
    /** 保存 */
    handleSave() {
      this.$refs['postForm'].validate(valid => {
        if (valid) {
          const that = this
          var path = ''
          const loading = this.$loading(KxjCom.loadOptions)

          const postForm = {
            entityData: that.postForm,
            tempFiles: that.fileListSche
          }
          path = '/api/services/app/WorkTaskSche/CreateOrUpdateWorkTaskSche'
          pathReq.dataUpdate(path, postForm).then(res => {
            that.$message.success('保存成功')
            this.$emit('save-success')
          }).then(_ => {
            loading.close()
            that.$refs['postForm'].resetFields()
            this.dailogShow = false
          })
        }
      })
    }

  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  margin-top: 10px;
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 100% !important;
}
</style>
